import { ProgramChainNote } from "../models/ProgramChainNote";
import { db } from "../../main";
import {getProgramChainRef} from './ProgramChainRepository';
import {firestore} from 'firebase';

function getProgramChainNotesRef() {
  return db.collection("programChainNotes");
}

export async function deleteProgramChainNote(programChainNote: ProgramChainNote) {
  return Promise.all([
    getProgramChainNotesRef()
    .doc(programChainNote.id)
    .delete(),
    getProgramChainRef(programChainNote.serialNumber, programChainNote.programChainId).update({
      numNotes: firestore.FieldValue.increment(-1)
    })
  ])
}


export async function saveProgramChainNote(programChainNote: ProgramChainNote) {
  return Promise.all([
    getProgramChainNotesRef()
    .doc(programChainNote.id)
    .set(programChainNote, { merge: true }),
    getProgramChainRef(programChainNote.serialNumber, programChainNote.programChainId).update({
      numNotes: firestore.FieldValue.increment(1)
    })
  ])
}

export function observeProgramChainNotes(
  programChainId: string,
  onNext: (programChainNotes: ProgramChainNote[]) => void
) {
  return getProgramChainNotesRef()
    .where("programChainId", "==", programChainId)
    .orderBy("createdAt", "desc")
    .onSnapshot((next) => {
      onNext(next.docs.map((doc) => doc.data() as ProgramChainNote));
    });
}
